import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['warning']

  connect() {
    this.timeout = parseInt(this.data.get('timeout')) * 1000
    this.warningBefore = parseInt(this.data.get('warningBefore')) * 1000

    if (!this.timeout || this.timeout <= 0) return

    this.storageKey = 'session_last_activity'
    this.activityEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click']
    this.resetTimer = this._resetTimer.bind(this)
    this.onStorageEvent = this._onStorageEvent.bind(this)

    this.activityEvents.forEach(event => {
      document.addEventListener(event, this.resetTimer, { passive: true })
    })
    window.addEventListener('storage', this.onStorageEvent)

    this._resetTimer()
  }

  disconnect() {
    if (this.activityEvents) {
      this.activityEvents.forEach(event => {
        document.removeEventListener(event, this.resetTimer)
      })
    }

    clearTimeout(this.warningTimer)
    clearTimeout(this.logoutTimer)
    clearInterval(this.countdownInterval)
    window.removeEventListener('storage', this.onStorageEvent)
  }

  _onStorageEvent(event) {
    if (event.key === this.storageKey) {
      this._resetTimer(false)
    }
  }

  _resetTimer(broadcast = true) {
    clearTimeout(this.warningTimer)
    clearTimeout(this.logoutTimer)
    clearInterval(this.countdownInterval)

    if (this.hasWarningTarget) {
      this.warningTarget.classList.add('hidden')
    }

    if (broadcast) {
      try { localStorage.setItem(this.storageKey, Date.now().toString()) } catch(e) {}
    }

    const warningAt = this.timeout - this.warningBefore

    this.warningTimer = setTimeout(() => {
      this._showWarning()
    }, warningAt)

    this.logoutTimer = setTimeout(() => {
      this._logout()
    }, this.timeout)
  }

  _showWarning() {
    if (!this.hasWarningTarget) return

    this.remainingSeconds = this.warningBefore / 1000
    this._updateCountdown()
    this.warningTarget.classList.remove('hidden')

    this.countdownInterval = setInterval(() => {
      this.remainingSeconds -= 1
      if (this.remainingSeconds <= 0) {
        clearInterval(this.countdownInterval)
      }
      this._updateCountdown()
    }, 1000)
  }

  _updateCountdown() {
    const el = this.warningTarget.querySelector('[data-countdown]')
    if (el) {
      const minutes = Math.floor(this.remainingSeconds / 60)
      const seconds = this.remainingSeconds % 60
      el.textContent = minutes > 0
        ? `${minutes}:${String(seconds).padStart(2, '0')}`
        : `${seconds}s`
    }
  }

  _logout() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    fetch('/users/sign_out', {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/html'
      }
    }).then(() => {
      window.location.href = '/login'
    }).catch(() => {
      window.location.href = '/login'
    })
  }

  continueSession(event) {
    event.preventDefault()
    this._resetTimer()
  }
}
